import React from "react";
import ReactDOM from "react-dom";
import http from '../modules/api';
import BasicDialogV2 from "../modules/dialogs/BasicDialogV2";
import PopupFrameV2 from '../modules/popup/PopupFrameV2';
import WarningDialog from '../modules/dialogs/WarningDialog';
import CheckBox from "../modules/common/CheckBox";

import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";

const FACEBOOK_APP_ID = '780456611206591';
const BASEDOMAIN = document.domain.indexOf("127.0.0.1") >= 0 ? 'https://127.0.0.1:8092' : window.location.origin;
// Instagram Login 신규 인증 엔드포인트. 로컬 React(3000)와 Spring Boot(8092)는 서로 다른 서버입니다.
// 기존 Facebook OAuth용 BASEDOMAIN 및 REDIRECT_URI는 변경하지 않습니다.
const INSTAGRAM_DIRECT_LOGIN_URL =
  (window.location.hostname === "127.0.0.1" || window.location.hostname === "localhost"
    ? `http://${window.location.hostname}:8092`
    : window.location.origin) + "/rest/shop/instagram/direct/login";
const REDIRECT_URI = BASEDOMAIN + '/rest/shop/instagram/callback';
const SCOPES = [
  'pages_show_list',
  // 'pages_read_engagement',
  'business_management',
  'instagram_basic',
  'instagram_content_publish',
  'instagram_manage_contents',
  'instagram_manage_insights',
  // 'catalog_management',
  // 'instagram_shopping_tag_products',
  'public_profile'
].join(',');

const FACEBOOK_OAUTH_RETURN_STATE_PREFIX = "robomd_return:";


const THREADS_OAUTH_CHANNEL_NAME = "robomd_threads_oauth";
const THREADS_OAUTH_STORAGE_KEY = "robomd_threads_oauth_event";

const THREADS_OAUTH_MOBILE_PENDING_KEY = "robomd_threads_oauth_mobile_pending";
const THREADS_OAUTH_MOBILE_GUIDE_DELAY_MS = 7000;

const isMobileThreadsOAuth = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isMobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return isMobileUserAgent || isIPadOS;
  } catch (e) {
    return false;
  }
};

const getThreadsMobileOS = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    if (/Android/i.test(userAgent)) return "android";
    if (/iPhone|iPad|iPod/i.test(userAgent) || isIPadOS) return "ios";
  } catch (e) {
    // OS 판별 실패 시 공통 모바일 안내를 사용한다.
  }
  return "mobile";
};

const saveThreadsMobileOAuthPending = (startedAt = Date.now()) => {
  try {
    sessionStorage.setItem(
      THREADS_OAUTH_MOBILE_PENDING_KEY,
      JSON.stringify({ startedAt, path: window.location.pathname || "" })
    );
  } catch (e) {
    // 저장소 사용이 제한되어도 OAuth 자체는 계속 진행한다.
  }
};

const readThreadsMobileOAuthPending = () => {
  try {
    const raw = sessionStorage.getItem(THREADS_OAUTH_MOBILE_PENDING_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch (e) {
    return null;
  }
};

const clearThreadsMobileOAuthPending = () => {
  try {
    sessionStorage.removeItem(THREADS_OAUTH_MOBILE_PENDING_KEY);
  } catch (e) {
    // 저장소 정리 실패는 무시한다.
  }
};

const publishThreadsOAuthBridgeMessage = (payload) => {
  const message = {
    ...payload,
    bridge_sent_at: Date.now(),
  };

  if (typeof BroadcastChannel !== "undefined") {
    try {
      const channel = new BroadcastChannel(THREADS_OAUTH_CHANNEL_NAME);
      channel.postMessage(message);
      setTimeout(() => channel.close(), 0);
    } catch (e) {
      console.warn("Threads OAuth BroadcastChannel 전송 실패:", e);
    }
  }

  // BroadcastChannel 미지원/차단 환경을 위한 동일 origin 탭 간 fallback
  try {
    localStorage.setItem(THREADS_OAUTH_STORAGE_KEY, JSON.stringify(message));
    localStorage.removeItem(THREADS_OAUTH_STORAGE_KEY);
  } catch (e) {
    console.warn("Threads OAuth storage 이벤트 전송 실패:", e);
  }

  return message;
};


const subscribeThreadsOAuthBridge = (handler) => {
  let channel = null;

  if (typeof BroadcastChannel !== "undefined") {
    try {
      channel = new BroadcastChannel(THREADS_OAUTH_CHANNEL_NAME);
      channel.onmessage = (e) => handler(e.data);
    } catch (e) {
      console.warn("Threads OAuth BroadcastChannel 연결 실패:", e);
    }
  }

  const onStorage = (e) => {
    if (e.key !== THREADS_OAUTH_STORAGE_KEY || !e.newValue) return;
    try {
      handler(JSON.parse(e.newValue));
    } catch (error) {
      console.warn("Threads OAuth storage 메시지 파싱 실패:", error);
    }
  };

  window.addEventListener("storage", onStorage);

  return () => {
    window.removeEventListener("storage", onStorage);
    if (channel) channel.close();
  };
};



const getFacebookOAuthReturnPath = () => {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete("facebook_oauth_status");
    url.searchParams.delete("facebook_oauth_token_id");
    return `${url.pathname}${url.search}`;
  } catch (e) {
    return window.location.pathname || "/shop/instagram/InstagramAccountManager";
  }
};

const isMobileFacebookOAuth = () => {
  try {
    const userAgent = navigator.userAgent || "";
    const isMobileUserAgent = /Android|iPhone|iPad|iPod|Mobile/i.test(userAgent);
    const isIPadOS = navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
    return isMobileUserAgent || isIPadOS;
  } catch (e) {
    return false;
  }
};

/**
 * Android 브라우저에서 facebook.com 링크가 Facebook 앱으로 App Link 처리되는 것을
 * 최대한 피하기 위해 링크 이동/window.open 대신 현재 탭의 GET form submit으로 OAuth를 시작한다.
 */
const submitFacebookOAuthForm = ({ redirectUri, returnPath = "" } = {}) => {
  const form = document.createElement("form");
  form.method = "GET";
  form.action = "https://www.facebook.com/v24.0/dialog/oauth";
  form.target = "_self";
  form.style.display = "none";

  const oauthParams = {
    client_id: FACEBOOK_APP_ID,
    redirect_uri: redirectUri,
    scope: SCOPES,
    response_type: "code",
  };

  // 모바일에서는 reauthenticate가 Facebook 앱 전환을 유발할 수 있어 제외한다.
  // PC에서는 기존 동작대로 재로그인을 유도한다.
  if (!isMobileFacebookOAuth()) {
    oauthParams.auth_type = "reauthenticate";
  }


  if (returnPath) {
    oauthParams.state = FACEBOOK_OAUTH_RETURN_STATE_PREFIX + encodeURIComponent(returnPath);
  }

  Object.entries(oauthParams).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  });

  document.body.appendChild(form);
  form.submit();
};

const params = new URLSearchParams(window.location.search);

export default class InstagramAccountManagerV2 extends React.Component {

  constructor(props) {
    super(props);
    this.threadsOAuthPending = false;
    this.threadsOAuthStartedAt = 0;
    this.threadsOAuthMobileWasHidden = false;
    this.threadsOAuthMobileGuideShown = false;
    this.threadsOAuthMobileGuideTimer = null;
    this.unsubscribeThreadsOAuthBridge = null;
    this.state = {
      status: params.get("status") || "",
      threads_status: params.get("threads_status") || "",
      token_id: params.get("token_id") || "",
      threads_user_id: params.get("threads_user_id") || "",
      threads_access_token_seq: params.get("threads_access_token_seq") || "",
      required_permission: params.get("required_permission") || "",
      selected_account_list : [],
      add_account_list: [],

      isConnected: props.isConnected ?? false,
      currentService: "",
      currentFacebookTokenId: "",
      showDisconnectModal: false,
      showFacebookDisconnectModal: false,
      showThreadsDisconnectModal: false,

      account_list: [],
      // 서버 인증 계정 기준 테스트 허용 여부. 기본값은 무조건 기존 Facebook Login.
      instagramDirectLoginEnabled: false,

      threads_account_list: [],
      add_threads_account_list: [],
      selected_threads_account_list: [],
      show_threads_account_connect_popup: false,
      show_threads_mobile_oauth_guide: false,
      threads_mobile_oauth_os: "",
      threads_oauth_manual_url: "",
      threads_oauth_manual_url_loading: false,
      threads_oauth_manual_copy_message: "",
      threads_loading: false,
      currentThreadsAccountName: "",
      currentThreadsAccessTokenSeq: "",

      // 계정별 토큰 헬스 상태 (token_id -> { status, message, need_user_login, reauthorize_url, missing_permissions_ko, token_info })
      healthByTokenId: {},
      // Threads 계정별 토큰/권한 헬스 상태 (threads_access_token_seq -> health)
      threadsHealthByTokenSeq: {},

      /* BasicDialog 변수 */
      basic_dialog_show_state: false,
      basic_dialog_content: "",
      basic_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({basic_dialog_show_state:false})}}],

      // show_account_connect_popup: true,

      title_content_dialog_title: "",
      title_content_dialog_content: "",
      title_content_dialog_button_list: [{title:"확인", event_method:()=>{this.setState({title_content_dialog_show_state:false})}}],
      title_content_dialog_show_state: false,

    };
  }

  componentDidMount() {
    http.get("/rest/shop/instagram/direct/status").then(({data}) => {
      this.setState({
        instagramDirectLoginEnabled: Boolean(data?.instagram_login_allowed && data?.instagram_login_configured && !data?.has_facebook_connection)
      });
    }).catch(() => this.setState({instagramDirectLoginEnabled:false}));

    this.unsubscribeThreadsOAuthBridge = subscribeThreadsOAuthBridge(this.handleThreadsOAuthBridgeMessage);
    document.addEventListener("visibilitychange", this.handleThreadsMobileOAuthVisibilityChange);
    window.addEventListener("focus", this.handleThreadsMobileOAuthFocus);

    const pendingThreadsOAuth = readThreadsMobileOAuthPending();
    const samePagePending = pendingThreadsOAuth
      && String(pendingThreadsOAuth.path || "") === String(window.location.pathname || "");

    if (!this.state.threads_status && isMobileThreadsOAuth() && samePagePending) {
      this.threadsOAuthPending = true;
      this.threadsOAuthStartedAt = Number(pendingThreadsOAuth.startedAt) || Date.now();
      this.threadsOAuthMobileWasHidden = true;
      this.scheduleThreadsMobileOAuthGuide(true);
    } else if (this.state.threads_status || !isMobileThreadsOAuth()) {
      clearThreadsMobileOAuthPending();
    }

    // alert("status : " + this.state.status + ", token_id : " + this.state.token_id);
    if (this.state.status == "success") {
      // Instagram 직접 인증을 같은 탭에서 시작한 경우 연결 계정 선택 팝업을 복원한다.
      const directSeq = params.get("direct_account_seq");
      if (directSeq && /^\d+$/.test(directSeq)) {
        const directTokenId = `IGD:${directSeq}`;
        this.setState({ token_id: directTokenId, show_account_connect_popup: true });
        this.loadInstagramAccountList(directTokenId);
      } else if (this.state.token_id) {
        // alert("token_id : " + this.state.token_id);
        this.loadInstagramAccountList(this.state.token_id);
        this.setState({
          show_account_connect_popup: true
        })
      }
    }
    // else {
      this.loadInstagramAccountList();
      this.loadThreadsAccountList();
      this.getRpStatus();

      if (this.state.required_permission === "instagram_manage_contents") {
        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "인스타그램에 발행된 콘텐츠를 삭제하려면 삭제 권한이 필요합니다.<br/>재연동을 통해 권한을 승인해주세요.",
          basic_dialog_button_list: [
            {
              title: "재연동",
              event_method: () => {
                this.setState({ basic_dialog_show_state: false }, () => {
                  this.handleConnectAccount();
                });
              }
            }
          ]
        });
      }

      if (this.state.threads_status === "success") {
        this.clearThreadsOAuthPendingState(true);
        if (this.state.threads_access_token_seq) {
          publishThreadsOAuthBridgeMessage({
            type: "refreshThreadsAccount",
            result: "success",
            threads_access_token_seq: this.state.threads_access_token_seq,
          });
          this.loadThreadsAccountForConnect(this.state.threads_access_token_seq);
        }
      } else if (this.state.threads_status === "fail") {
        this.clearThreadsOAuthPendingState(true);
        publishThreadsOAuthBridgeMessage({
          type: "refreshThreadsAccount",
          result: "fail",
          threads_access_token_seq: "",
        });
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "Threads 계정 연결에 실패했습니다.",
        });
      }
    // }
  }

  componentWillUnmount() {
    this.clearThreadsMobileOAuthGuideTimer();
    if (this.unsubscribeThreadsOAuthBridge) {
      this.unsubscribeThreadsOAuthBridge();
      this.unsubscribeThreadsOAuthBridge = null;
    }
    document.removeEventListener("visibilitychange", this.handleThreadsMobileOAuthVisibilityChange);
    window.removeEventListener("focus", this.handleThreadsMobileOAuthFocus);
    // 현재 탭 OAuth 이동 중에는 callback 미수신 상태를 복원해야 하므로 sessionStorage pending은 유지한다.
  }

  /* =========================
   *  Facebook OAuth Connect
   * ========================= */
  handleConnect = async () => {
    let useInstagramDirect = false;
    try {
      const {data} = await http.get("/rest/shop/instagram/direct/status");
      useInstagramDirect = Boolean(data?.instagram_login_allowed && data?.instagram_login_configured && !data?.has_facebook_connection);
    } catch (e) { /* 기존 Facebook Login 유지 */ }
    if (useInstagramDirect) {
      const confirmed = await this.openConfirmDialog({
        title: "Instagram 계정으로 직접 로그인하시겠습니까?",
        content: "비즈니스 또는 크리에이터 계정을 연결합니다."
      });
      if (confirmed) window.location.assign(INSTAGRAM_DIRECT_LOGIN_URL);
      return;
    }
    const result = await this.openConfirmDialog({
      title: "인스타그램 계정 추가를 위해<br/>페이스북 로그인 페이지로 이동하시겠습니까?",
      content: "",
    });

    if (!result) {
      return;
    }

    submitFacebookOAuthForm({
      redirectUri: REDIRECT_URI,
    });
  };

  handleConnectAccount = async () => {
    let useInstagramDirect = false;
    try {
      const {data} = await http.get("/rest/shop/instagram/direct/status");
      useInstagramDirect = Boolean(data?.instagram_login_allowed && data?.instagram_login_configured && !data?.has_facebook_connection);
    } catch (e) { /* 기존 Facebook Login 유지 */ }
    if (useInstagramDirect) {
      const confirmed = await this.openConfirmDialog({
        title: "Instagram 계정으로 직접 로그인하시겠습니까?",
        content: "비즈니스 또는 크리에이터 계정을 연결합니다."
      });
      if (confirmed) window.location.assign(INSTAGRAM_DIRECT_LOGIN_URL);
      return;
    }
    const result = await this.openConfirmDialog({
      title: "인스타그램 계정 연동을 위해<br/>페이스북 로그인 페이지로 이동하시겠습니까?",
      content: "",
    });

    if (!result) {
      return;
    }

    submitFacebookOAuthForm({
      redirectUri: REDIRECT_URI,
    });
  };



  clearThreadsMobileOAuthGuideTimer = () => {
    if (this.threadsOAuthMobileGuideTimer) {
      window.clearTimeout(this.threadsOAuthMobileGuideTimer);
      this.threadsOAuthMobileGuideTimer = null;
    }
  };

  markThreadsOAuthStarted = () => {
    this.clearThreadsMobileOAuthGuideTimer();
    this.threadsOAuthPending = true;
    this.threadsOAuthStartedAt = Date.now();
    this.threadsOAuthMobileWasHidden = false;
    this.threadsOAuthMobileGuideShown = false;

    if (isMobileThreadsOAuth()) {
      saveThreadsMobileOAuthPending(this.threadsOAuthStartedAt);
      this.scheduleThreadsMobileOAuthGuide(false);
    } else {
      clearThreadsMobileOAuthPending();
    }
  };

  clearThreadsOAuthPendingState = (hideGuide = true) => {
    this.clearThreadsMobileOAuthGuideTimer();
    this.threadsOAuthPending = false;
    this.threadsOAuthStartedAt = 0;
    this.threadsOAuthMobileWasHidden = false;
    this.threadsOAuthMobileGuideShown = false;
    clearThreadsMobileOAuthPending();

    if (hideGuide) {
      this.setState({
        show_threads_mobile_oauth_guide: false,
        threads_oauth_manual_copy_message: "",
      });
    }
  };

  scheduleThreadsMobileOAuthGuide = (returnedToPage = false) => {
    if (!isMobileThreadsOAuth() || !this.threadsOAuthPending || this.threadsOAuthMobileGuideShown) return;

    this.clearThreadsMobileOAuthGuideTimer();

    const startedAt = this.threadsOAuthStartedAt || Date.now();
    const elapsed = Math.max(0, Date.now() - startedAt);
    const delay = returnedToPage
      ? 1000
      : Math.max(0, THREADS_OAUTH_MOBILE_GUIDE_DELAY_MS - elapsed);

    this.threadsOAuthMobileGuideTimer = window.setTimeout(() => {
      this.threadsOAuthMobileGuideTimer = null;
      if (!this.threadsOAuthPending || this.threadsOAuthMobileGuideShown) return;
      if (document.visibilityState === "hidden") return;

      this.threadsOAuthMobileGuideShown = true;
      this.setState(
        {
          show_threads_mobile_oauth_guide: true,
          threads_mobile_oauth_os: getThreadsMobileOS(),
          threads_oauth_manual_url: "",
          threads_oauth_manual_url_loading: true,
          threads_oauth_manual_copy_message: "",
        },
        this.loadThreadsOAuthManualUrl
      );
    }, delay);
  };

  handleThreadsMobileOAuthVisibilityChange = () => {
    if (!this.threadsOAuthPending || !isMobileThreadsOAuth()) return;

    if (document.visibilityState === "hidden") {
      this.threadsOAuthMobileWasHidden = true;
      return;
    }

    if (document.visibilityState === "visible") {
      this.scheduleThreadsMobileOAuthGuide(this.threadsOAuthMobileWasHidden);
    }
  };

  handleThreadsMobileOAuthFocus = () => {
    if (!this.threadsOAuthPending || !isMobileThreadsOAuth()) return;

    const elapsed = Date.now() - (this.threadsOAuthStartedAt || Date.now());
    const returnedToPage = this.threadsOAuthMobileWasHidden || elapsed >= 2500;
    this.scheduleThreadsMobileOAuthGuide(returnedToPage);
  };

  loadThreadsOAuthManualUrl = () => {
    return http.get("/rest/shop/threds/auth-url?return_to_parent=Y")
      .then((res) => {
        const authUrl = String(res?.data?.auth_url || "").trim();
        this.setState({
          threads_oauth_manual_url: authUrl,
          threads_oauth_manual_url_loading: false,
        });
        return authUrl;
      })
      .catch((error) => {
        console.error("Threads 수동 인증 주소 조회 실패:", error);
        this.setState({
          threads_oauth_manual_url: "",
          threads_oauth_manual_url_loading: false,
          threads_oauth_manual_copy_message: "인증 주소를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
        });
        return "";
      });
  };

  copyThreadsOAuthManualUrl = () => {
    const authUrl = String(this.state.threads_oauth_manual_url || "").trim();
    if (!authUrl) {
      this.setState({
        threads_oauth_manual_copy_message: this.state.threads_oauth_manual_url_loading
          ? "인증 주소를 준비 중입니다."
          : "인증 주소를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
      });
      return;
    }

    const onCopied = () => this.setState({ threads_oauth_manual_copy_message: "인증 주소를 복사했습니다." });
    const fallbackCopy = () => {
      try {
        const textarea = document.createElement("textarea");
        textarea.value = authUrl;
        textarea.setAttribute("readonly", "readonly");
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        const copied = document.execCommand("copy");
        textarea.remove();
        if (copied) onCopied();
        else throw new Error("copy failed");
      } catch (e) {
        this.setState({ threads_oauth_manual_copy_message: "인증 주소 복사에 실패했습니다." });
      }
    };

    if (navigator.clipboard && typeof navigator.clipboard.writeText === "function") {
      navigator.clipboard.writeText(authUrl).then(onCopied).catch(fallbackCopy);
    } else {
      fallbackCopy();
    }
  };

  closeThreadsMobileOAuthGuide = () => {
    this.setState({
      show_threads_mobile_oauth_guide: false,
      threads_oauth_manual_copy_message: "",
    });
  };

  retryThreadsOAuthFromGuide = () => {
    this.closeThreadsMobileOAuthGuide();
    if (typeof this.stopThreadsOAuthPolling === "function") {
      this.stopThreadsOAuthPolling(true);
    }
    this.clearThreadsOAuthPendingState(false);
    this.handleThreadsConnect();
  };

  renderThreadsMobileOAuthGuide = () => {
    if (!this.state.show_threads_mobile_oauth_guide) return null;

    const os = this.state.threads_mobile_oauth_os || getThreadsMobileOS();
    const isAndroid = os === "android";
    const isIOS = os === "ios";
    const manualUrlReady = !!String(this.state.threads_oauth_manual_url || "").trim();

    return (
      <PopupFrameV2
        className={"threads-mobile-oauth-guide-popup"}
        maxWidth={"620px"}
        onClose={this.closeThreadsMobileOAuthGuide}
      >
        <div style={{ padding: "26px 28px 24px", color: "#0A1A2F", lineHeight: 1.65, wordBreak: "keep-all" }}>
          <h5 style={{ margin: "0 0 12px", fontSize: "20px" }}>Threads 연결이 잘 안 되나요?</h5>
          <div style={{ fontSize: "14px", color: "#4b5563" }}>
            모바일에서는 Threads 앱이 자동으로 열리면서 계정 연결이 중간에 멈출 수 있습니다.
            <br />아래 방법으로 다시 진행해 주세요.
          </div>

          {isAndroid && (
            <div style={{ marginTop: "18px" }}>
              <div style={{ fontWeight: 800, marginBottom: "8px" }}>방법 1. Threads 앱이 자동으로 열리지 않게 설정하기</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 휴대폰 <b>설정 → 앱 → Threads → 기본으로 설정</b>으로 이동해 주세요.
                <br />2. <b>이 앱으로 열기</b>를 꺼 주세요. 기기에 따라 <b>지원되는 웹 주소</b>로 표시될 수 있습니다.
                <br />3. 아래 <b>다시 연결</b>을 눌러 주세요.
              </div>

              <div style={{ fontWeight: 800, margin: "18px 0 8px" }}>방법 2. 인증 주소를 브라우저에서 직접 열기</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 아래 <b>인증 주소 복사</b>를 눌러 주세요.
                <br />2. 지금 RoboMD를 보고 있는 <b>같은 브라우저에서 새 탭</b>을 열어 주세요.
                <br />3. 새 탭의 주소창에 붙여넣고 Threads 인증을 진행해 주세요.
                <br />4. 인증 완료 안내가 나오면 그 탭을 닫고 원래 RoboMD 탭으로 돌아와 주세요.
              </div>
            </div>
          )}

          {isIOS && (
            <div style={{ marginTop: "18px" }}>
              <div style={{ fontWeight: 800, marginBottom: "8px" }}>인증 주소를 브라우저에서 직접 열어 주세요</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 아래 <b>인증 주소 복사</b>를 눌러 주세요.
                <br />2. 지금 RoboMD를 보고 있는 <b>같은 브라우저에서 새 탭</b>을 열어 주세요.
                <br />3. 새 탭의 주소창에 붙여넣고 Threads 인증을 진행해 주세요.
                <br />4. 인증 완료 안내가 나오면 그 탭을 닫고 원래 RoboMD 탭으로 돌아와 주세요.
              </div>
            </div>
          )}

          {!isAndroid && !isIOS && (
            <div style={{ marginTop: "18px" }}>
              <div style={{ fontWeight: 800, marginBottom: "8px" }}>인증 주소를 브라우저에서 직접 열어 주세요</div>
              <div style={{ fontSize: "14px", color: "#374151", lineHeight: 1.8 }}>
                1. 아래 <b>인증 주소 복사</b>를 눌러 주세요.
                <br />2. 지금 RoboMD를 보고 있는 <b>같은 브라우저에서 새 탭</b>을 열어 주세요.
                <br />3. 새 탭의 주소창에 붙여넣고 Threads 인증을 진행해 주세요.
                <br />4. 인증 완료 안내가 나오면 그 탭을 닫고 원래 RoboMD 탭으로 돌아와 주세요.
              </div>
            </div>
          )}

          <div style={{ marginTop: "16px", padding: "12px 14px", background: "#f8fafc", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", color: "#4b5563" }}>
            <b>중요:</b> 지금 보고 있는 RoboMD 탭은 닫지 마세요. 인증이 끝나면 이 화면에서 연결할 Threads 계정을 선택할 수 있습니다.
          </div>

          {this.state.threads_oauth_manual_copy_message && (
            <div style={{ marginTop: "10px", fontSize: "13px", color: "#374151" }}>
              {this.state.threads_oauth_manual_copy_message}
            </div>
          )}

          <div style={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: "8px", marginTop: "22px" }}>
            <button type="button" className="btn" onClick={this.closeThreadsMobileOAuthGuide}>
              닫기
            </button>
            <button
              type="button"
              className="btn"
              disabled={this.state.threads_oauth_manual_url_loading || !manualUrlReady}
              onClick={this.copyThreadsOAuthManualUrl}
              style={{ opacity: this.state.threads_oauth_manual_url_loading || !manualUrlReady ? 0.55 : 1 }}
            >
              {this.state.threads_oauth_manual_url_loading ? "인증 주소 준비 중" : "인증 주소 복사"}
            </button>
            {isAndroid && (
              <button type="button" className="btn btn-primary" onClick={this.retryThreadsOAuthFromGuide}>
                다시 연결
              </button>
            )}
          </div>
        </div>
      </PopupFrameV2>
    );
  };


  handleThreadsOAuthBridgeMessage = (data) => {
    if (!data || data.type !== "refreshThreadsAccount") return;
    if (!this.threadsOAuthPending) return;

    const result = String(data.result || "").toLowerCase();
    const accessTokenSeq = String(data.threads_access_token_seq || "");
    this.clearThreadsOAuthPendingState(true);

    if (result === "success" && accessTokenSeq) {
      this.loadThreadsAccountForConnect(accessTokenSeq);
      return;
    }

    this.setState({
      warning_dialog_show_state: true,
      warning_dialog_content: "Threads 로그인 또는 권한 승인이 완료되지 않았습니다.",
    });
  };

  handleThreadsConnect = () => {
    // 계정관리에서는 현재 탭에서 RoboMD 서버의 Redirect 엔드포인트로 이동한다.
    // 모바일에서 앱으로 전환되어 callback이 오지 않는 경우를 감지할 수 있도록 pending 상태를 남긴다.
    this.markThreadsOAuthStarted();
    window.location.href = "/rest/shop/threds/auth-redirect";
  };

  /* =========================
   *  Modal Controls
   * ========================= */
  openModal = (service) => {
    this.setState({ currentService: service, showDisconnectModal: true });
  };

  closeModal = () => {
    this.setState({ showDisconnectModal: false });
  };

  disconnect = () => {
    // alert(this.state.currentService + " 연결이 해제되었습니다.");
    this.setState({
      basic_dialog_show_state: true,
      basic_dialog_content: "연결이 해제되었습니다.",
    });
    this.closeModal();
  };

  openFacebookModal = (token_id, name) => {
    this.setState({
      currentfacebookAccountName: name,
      currentFacebookTokenId: token_id,
      showFacebookDisconnectModal: true,
    });
  };

  closeFacebookModal = () => {
    this.setState({
      currentfacebookAccountName: "",
      currentFacebookTokenId: "",
      showFacebookDisconnectModal: false,
    });
  };


  openThreadsModal = (threads_access_token_seq, username) => {
    this.setState({
      currentThreadsAccountName: username,
      currentThreadsAccessTokenSeq: threads_access_token_seq,
      showThreadsDisconnectModal: true,
    });
  };

  closeThreadsModal = () => {
    this.setState({
      currentThreadsAccountName: "",
      currentThreadsAccessTokenSeq: "",
      showThreadsDisconnectModal: false,
    });
  };

  toggleConnection = () => {
    this.setState((s) => ({ isConnected: !s.isConnected }));
  };

  /* =========================
   *  API Calls
   * ========================= */
  loadInstagramAccountList(token_id) {
    if (token_id) {
      http.get("/rest/shop/instagram/profile/list?token_id=" + token_id)
        .then(res => {
          if (res.data.list != null) {
            this.setState({
              add_account_list: res.data.list,
            });
          }
        }).catch(error => {
          console.log(error);
        })
    }
    else {
      http.get("/rest/shop/instagram/profile/list")
        .then(res => {
          if (res.data.list != null) {
            const instagramList = res.data.list || [];
            this.setState(
              prev => ({
                account_list: instagramList,
                isConnected: instagramList.length > 0 || (prev.threads_account_list || []).length > 0
              }),
              () => {
                // 계정별 토큰 헬스 검사
                this.state.account_list.forEach((acc) => {
                  if (acc.auth_provider === "INSTAGRAM") {
                    this.checkInstagramDirectTokenStatusForAccount(acc);
                  } else {
                    this.checkFacebookTokenStatusForAccount(acc);
                  }
                });
              }
            );
          }
        }).catch(error => {
          console.log(error);
        })
    }
  }

  loadThreadsAccountList = () => {
    this.setState({ threads_loading: true });
    return http.get("/rest/shop/threds/profile/list")
      .then(res => {
        const list = res?.data?.list || [];
        this.setState(prev => ({
          threads_account_list: list,
          threads_loading: false,
          isConnected: (prev.account_list || []).length > 0 || list.some((threads) => threads && String(threads.use_yn || "").toUpperCase() === "Y")
        }), () => {
          // Instagram과 동일하게 계정 목록 로드 후 실제 토큰/권한 상태를 갱신한다.
          list.forEach((threads) => this.checkThreadsTokenStatusForAccount(threads));
        });
        return list;
      })
      .catch(error => {
        console.log(error);
        this.setState({ threads_loading: false });
        return [];
      });
  };

  loadThreadsAccountForConnect = (threadsAccessTokenSeq) => {
    const targetSeq = String(threadsAccessTokenSeq || "");
    if (!targetSeq) return;

    http.get("/rest/shop/threds/profile/list")
      .then(res => {
        const list = Array.isArray(res?.data?.list) ? res.data.list : [];
        const addThreadsAccountList = list.filter(
          (threads) => threads && String(threads.threads_access_token_seq) === targetSeq
        );

        if (addThreadsAccountList.length === 0) {
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "연결할 Threads 계정 정보를 불러오지 못했습니다.",
          });
          return;
        }

        this.setState({
          threads_account_list: list,
          add_threads_account_list: addThreadsAccountList,
          selected_threads_account_list: [],
          show_threads_account_connect_popup: true,
        });
      })
      .catch(error => {
        console.log(error);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "Threads 계정 정보를 불러오는 중 오류가 발생했습니다.",
        });
      });
  };

  disconnectThreadsAccount = (threads_access_token_seq) => {
    http.post("/rest/shop/threds/disconnect?threads_access_token_seq=" + threads_access_token_seq)
      .then(res => {
        const data = res?.data || {};
        if (data.status === "success") {
          this.setState({
            basic_dialog_show_state: true,
            basic_dialog_content: "Threads 계정 연결이 해제되었습니다.",
            currentThreadsAccountName: "",
            currentThreadsAccessTokenSeq: "",
            showThreadsDisconnectModal: false,
          });
          this.loadThreadsAccountList();
        } else {
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "Threads 계정 연결 해제에 실패했습니다."
          });
        }
      }).catch(error => {
        console.log(error);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "Threads 연결 해제 요청 중 오류가 발생했습니다."
        });
      });
  };

  toggleThreadsConnectSelection = (threadsAccessTokenSeq) => {
    const value = String(threadsAccessTokenSeq || "");
    if (!value) return;

    this.setState((prev) => {
      const selected = (prev.selected_threads_account_list || []).map(String);
      const next = selected.includes(value)
        ? selected.filter((seq) => seq !== value)
        : [...selected, value];
      return { selected_threads_account_list: next };
    });
  };

  updateThreadsAccountsUseYn = (selectedAccountList, useYn = "Y") => {
    return http.post(
      "/rest/shop/threds/updateAccountsUseYn",
      { selected_account_list: selectedAccountList, use_yn: useYn },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
  };

  updateSelectedThreadsAccountsUseYn = () => {
    const selected = (this.state.selected_threads_account_list || []).map(String);

    if (selected.length === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "하나 이상의 계정을 선택 해 주세요.",
      });
      return;
    }

    this.updateThreadsAccountsUseYn(selected, "Y")
      .then((res) => {
        const data = res?.data || {};
        if (String(data.status || "").toLowerCase() === "success") {
          this.setState({
            show_threads_account_connect_popup: false,
            add_threads_account_list: [],
            selected_threads_account_list: [],
          });
          this.loadThreadsAccountList();
        } else {
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: data.message || "Threads 계정 업데이트에 실패했습니다.",
          });
        }
      })
      .catch((error) => {
        console.error("Threads 계정 업데이트 실패:", error);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "서버 요청 중 오류가 발생했습니다.",
        });
      });
  };

  updateAccountsUseYn = (token_id, selected_account_list, use_yn) => {
    return http.post(
      "/rest/shop/instagram/updateAccountsUseYn",
      { token_id, selected_account_list, use_yn },
      {
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
      }
    );
  };

  updateSelectedAccountsUseYn = () => {
    const { token_id, selected_account_list } = this.state;

    if (!token_id) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "토큰 정보가 없습니다. 다시 연동해주세요."
      });
      return;
    }

    if (!selected_account_list || selected_account_list.length === 0) {
      this.setState({
        warning_dialog_show_state: true,
        warning_dialog_content: "하나 이상의 계정을 선택 해 주세요."
      });
      return;
    }

    this.updateAccountsUseYn(token_id, selected_account_list, "Y")
      .then((res) => {
        const data = res && res.data ? res.data : {};
        if (String(data.code) === "200") {
          console.log("SUCCESS cnt:", data.cnt);
          window.location.href = "/shop/instagram/InstagramAccountManager";
        } else {
          console.log("FAIL:", data);
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: "계정 업데이트에 실패했습니다."
          });
        }
      })
      .catch((err) => {
        console.error("ERROR:", err);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "서버 요청 중 오류가 발생했습니다."
        });
      });
  };

  // 계정별 Facebook 토큰 상태 검사 + 자동 갱신 시도
  checkFacebookTokenStatusForAccount = async (account) => {
    console.log("[checkFacebookTokenStatusForAccount] account:", account);
    const token_id = account.token_id;
    console.log("[checkFacebookTokenStatusForAccount] token_id:", token_id);
    try {
        if (!token_id) {
          console.warn("[checkFacebookTokenStatusForAccount] missing token_id for account:", account);
          return;
        }
  
        // 서버에 instagram_access_token_seq 전달
        const resp = await http.get("/rest/shop/instagram/check-token-permissions", {
          params: { token_id: token_id }
        });
  
        const data = resp?.data || {};
        this.setState(prev => ({
          healthByTokenId: {
            ...prev.healthByTokenId,
            [token_id]: {
              status: data.status || "UNKNOWN",
              message: data.message || "",
              need_user_login: !!data.need_user_login,
              reauthorize_url: data.reauthorize_url,
              service_available: data.service_available !== false,
              reauthorization_required: !!data.reauthorization_required,
              limited_features: data.limited_features || [],
              missing_permissions_en: data.missing_permissions_en || [],
              missing_permissions_ko: data.missing_permissions_ko || [],
              token_info: data.token_info || {},
            }
          }
        }));
    } catch (e) {
      console.error("[checkFacebookTokenStatusForAccount] error:", e);
      this.setState(prev => ({
        healthByTokenId: {
          ...prev.healthByTokenId,
          [token_id]: {
            status: "ERROR",
            message: e?.message || "토큰 검사 중 오류가 발생했습니다.",
            need_user_login: true
          }
        }
      }));
    }
  };

  // Instagram Login 계정은 Facebook /me/permissions가 아닌 IGD 토큰 검사 API를 사용한다.
  // 기본 API는 실시간 검사하고, 인사이트 접근 상태는 전용 정기 점검 결과를 표시한다.
  checkInstagramDirectTokenStatusForAccount = async (account) => {
    const accountSeq = account?.instagram_account_list?.[0]?.instagram_access_token_seq;
    const tokenId = String(account?.token_id || (accountSeq ? `IGD:${accountSeq}` : ""));
    if (!tokenId.startsWith("IGD:")) return;

    this.setState((prev) => ({
      healthByTokenId: {
        ...prev.healthByTokenId,
        [tokenId]: { status: "CHECKING", auth_provider: "INSTAGRAM" }
      }
    }));
    try {
      const response = await http.get("/rest/shop/instagram/check-token-permissions", {
        params: { token_id: tokenId }
      });
      const data = response?.data || {};
      this.setState((prev) => ({
        healthByTokenId: {
          ...prev.healthByTokenId,
          [tokenId]: {
            ...data,
            auth_provider: "INSTAGRAM",
            status: data.status || "CHECK_FAILED",
            message: data.message || "",
            service_available: data.service_available !== false,
            need_user_login: !!data.need_user_login,
            reauthorization_required: !!data.reauthorization_required,
            missing_permissions_en: data.missing_permissions_en || [],
            missing_permissions_ko: data.missing_permissions_ko || []
          }
        }
      }));
    } catch (error) {
      console.warn("[Instagram Direct] 계정 상태 확인 실패:", error?.response?.status || error?.message);
      this.setState((prev) => ({
        healthByTokenId: {
          ...prev.healthByTokenId,
          [tokenId]: {
            status: "CHECK_FAILED",
            auth_provider: "INSTAGRAM",
            message: "Instagram 계정의 상태를 확인하지 못했습니다. 잠시 후 다시 확인해 주세요.",
            service_available: true,
            need_user_login: false,
            missing_permissions_en: [],
            missing_permissions_ko: []
          }
        }
      }));
    }
  };

  // Threads 계정별 토큰/권한 상태 검사 (Instagram 계정 헬스 UX와 동일한 목적)
  checkThreadsTokenStatusForAccount = async (account) => {
    const threadsAccessTokenSeq = account?.threads_access_token_seq;
    if (!threadsAccessTokenSeq) return;

    try {
      const resp = await http.get("/rest/shop/threds/check-token-permissions", {
        params: { threads_access_token_seq: threadsAccessTokenSeq }
      });
      const data = resp?.data || {};
      this.setState(prev => ({
        threadsHealthByTokenSeq: {
          ...prev.threadsHealthByTokenSeq,
          [String(threadsAccessTokenSeq)]: {
            status: data.health_status || data.status || "UNKNOWN",
            message: data.message || "",
            need_user_login: !!data.need_user_login,
            service_available: data.service_available !== false,
            reauthorization_required: !!data.reauthorization_required,
            missing_permissions_en: data.missing_permissions_en || [],
            missing_permissions_ko: data.missing_permissions_ko || [],
            expires_at: data.expires_at
          }
        }
      }));
    } catch (e) {
      console.error("[checkThreadsTokenStatusForAccount] error:", e);
      this.setState(prev => ({
        threadsHealthByTokenSeq: {
          ...prev.threadsHealthByTokenSeq,
          [String(threadsAccessTokenSeq)]: {
            status: "CHECK_FAILED",
            message: "Threads 계정의 연결 상태를 확인하지 못했습니다.",
            need_user_login: false,
            service_available: true,
            missing_permissions_en: [],
            missing_permissions_ko: []
          }
        }
      }));
    }
  };

  disconnectAllPermissions(token_id) {
    http.post("/rest/shop/instagram/disconnect/allPermissions?token_id=" + token_id)
      .then(res => {
        // alert("페이스북 계정 연결이 해제되었습니다.");
        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "페이스북 계정 연결이 해제되었습니다.",
        });
        this.setState({
          currentfacebookAccountName: "",
          currentFacebookTokenId: "",
          showFacebookDisconnectModal: false,
        });
        this.loadInstagramAccountList();
      }).catch(error => {
        console.log(error);
      })
  }

  setDefaultInstagram(instagram_access_token_seq) {
    http.post("/rest/shop/instagram/default?instagram_access_token_seq=" + instagram_access_token_seq)
      .then(res => {
        // alert("기본으로 설정 되었습니다.");
        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "기본으로 설정 되었습니다.",
        });
        this.setState({
          currentfacebookAccountName: "",
          currentFacebookTokenId: "",
          showFacebookDisconnectModal: false,
        });
        this.loadInstagramAccountList();
      }).catch(error => {
        console.log(error);
      })
  }

  setDefaultThreads(threads_access_token_seq) {
    http.post("/rest/shop/threds/default?threads_access_token_seq=" + threads_access_token_seq)
      .then(res => {
        const data = res?.data || {};
        if (String(data.status || "").toLowerCase() !== "success") {
          this.setState({
            warning_dialog_show_state: true,
            warning_dialog_content: data.message || "Threads 기본 계정 설정에 실패했습니다.",
          });
          return;
        }

        this.setState({
          basic_dialog_show_state: true,
          basic_dialog_content: "기본으로 설정 되었습니다.",
        });
        this.loadThreadsAccountList();
      }).catch(error => {
        console.log(error);
        this.setState({
          warning_dialog_show_state: true,
          warning_dialog_content: "Threads 기본 계정 설정 중 오류가 발생했습니다.",
        });
      });
  }

  getRpStatus() {
    http.get("/rest/shop/instagram/rp/status")
      .then(res => {
        const data = res.data;
        this.setState({
          rp_added_type: data.added_type,
          rp_is_finish: data.is_finish,
          rp_payment_yn: data.payment_yn,
        });
      }).catch(error => {
        console.log(error);
      })
  }

  goRpService() {
    http.get("/rest/common/changeServiceType?service_type=01002")
      .then(res => {
        const data = res.data;
        window.location.href = data.redirectUrl;
      }).catch(error => {
        console.log(error);
      })
  }

  /* =========================
   *  Renders
   * ========================= */
  renderThreadsSection() {
    const list = (this.state.threads_account_list || []).filter(
      (threads) => threads && String(threads.use_yn || "").toUpperCase() === "Y"
    );
    const hasThreads = list.length > 0;

    return (
      <div className="section">
        <div className="section-header">
          <h2 className="section-title">Threads 계정</h2>
          <button className="btn btn-add" onClick={this.handleThreadsConnect}>
            <span>+</span> Threads 계정 추가
          </button>
        </div>

        {!hasThreads ? (
          <div className="empty-card" style={{ marginTop: 0 }}>
            <div className="empty-icon">T</div>
            <div className="empty-title">연결된 Threads 계정이 없습니다</div>
            <div className="empty-text">
              Threads는 Facebook/Instagram 토큰과 별도로 인증이 필요합니다.<br />
              Threads 계정을 연결하면 게시 자동화 확장에 사용할 수 있습니다.
            </div>
            <button className="btn btn-add" onClick={this.handleThreadsConnect}>
              <span>+</span> Threads 연결하기
            </button>
          </div>
        ) : (
          <div className="instagram-accounts">
            {list.map((threads) => {
              const seq = String(threads.threads_access_token_seq || "");
              const checkedHealth = this.state.threadsHealthByTokenSeq[seq] || {};
              const status = checkedHealth.status || threads.health_status || "";
              const healthMessage = checkedHealth.message || threads.message || "";
              const missingPermissionsEn = checkedHealth.missing_permissions_en || threads.missing_permissions_en || [];
              const missingPermissionsKo = checkedHealth.missing_permissions_ko || threads.missing_permissions_ko || [];

              // Instagram의 삭제 전용 권한 누락 UX와 동일하게 Threads 삭제 권한만 없으면
              // 게시/인사이트 등 서비스는 사용 가능하게 유지하고 재연동만 안내한다.
              const isLegacyDeleteOnlyMissing =
                status === "MISSING_PERMISSIONS" &&
                missingPermissionsEn.length > 0 &&
                missingPermissionsEn.every(permission => permission === "threads_delete");
              const isLimitedPermission = status === "LIMITED_PERMISSIONS" || isLegacyDeleteOnlyMissing;
              const isServiceUnavailable =
                (!isLimitedPermission && status === "MISSING_PERMISSIONS") ||
                status === "TOKEN_INVALID_OR_EXPIRED";
              const showReconnectButton = isLimitedPermission || isServiceUnavailable;
              const profileImage = threads.profile_picture_url;

              const followerCount = threads.follower_count != null ? Number(threads.follower_count) : null;
              const viewCount = threads.view_cnt != null ? Number(threads.view_cnt) : null;
              const engagementRate = threads.engagement_rate != null ? Number(threads.engagement_rate) : null;
              const formatCount = (value) => {
                if (value == null || Number.isNaN(value)) return "-";
                return value < 1000 ? value : (value / 1000).toFixed(1) + "K";
              };

              return (
                <div
                  className="account-card"
                  key={threads.threads_access_token_seq}
                  style={{ opacity: (isServiceUnavailable ? 0.5 : 1) }}
                >
                  <div className="account-wrapper">
                    <div className="account-left">
                      <div className="account-avatar threads-avatar">
                        {profileImage ? (
                          <img src={profileImage} alt="" />
                        ) : (
                          <span>T</span>
                        )}
                      </div>
                      <div className="account-info">
                        <div className="account-username">
                          {threads.username || threads.threads_user_id || "Threads 계정"}
                          {String(threads.default_yn || "").toUpperCase() === "Y" && (
                            <span className="default-badge">기본</span>
                          )}
                        </div>
                        <div className="account-stats">
                          <span className="stat-item">팔로워
                            <span className="stat-value">{formatCount(followerCount)}</span>
                          </span>
                          <span className="stat-item">조회
                            <span className="stat-value">{formatCount(viewCount)}</span>
                          </span>
                          <span className="stat-item">참여율
                            <span className="stat-value">
                              {engagementRate != null && !Number.isNaN(engagementRate) ? engagementRate.toFixed(1) + '%' : '-'}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="account-right">
                      {showReconnectButton && (
                        <button className="btn-outline" onClick={this.handleThreadsConnect}>
                          재연동
                        </button>
                      )}
                      {!isServiceUnavailable && String(threads.default_yn || "").toUpperCase() !== "Y" && (
                        <button
                          className="btn-outline"
                          onClick={() => this.setDefaultThreads(threads.threads_access_token_seq)}
                        >
                          기본으로 설정
                        </button>
                      )}
                      <button
                        className="btn-outline"
                        onClick={() => this.openThreadsModal(threads.threads_access_token_seq, threads.username || threads.threads_user_id)}
                      >
                        연결 해제
                      </button>
                    </div>
                  </div>

                  {isLimitedPermission && (
                    <div className="permission-alert permission-alert-limited" style={{ marginTop: "12px" }}>
                      <span className="permission-alert-icon permission-alert-info-icon">i</span>
                      <div className="permission-alert-text">
                        Threads에 발행된 콘텐츠를 삭제하려면 "재연동"을 통해 삭제 권한을 승인해주세요.
                      </div>
                    </div>
                  )}

                  {isServiceUnavailable && (
                    <div className="permission-alert" style={{ marginTop: "12px" }}>
                      <span className="permission-alert-icon">⚠️</span>
                      <div className="permission-alert-text">
                        <strong>
                          {healthMessage
                            ? healthMessage
                            : missingPermissionsKo.length > 0
                              ? "필수 권한이 누락되었습니다."
                              : "Threads 계정 재연동이 필요합니다."}
                        </strong>
                        {missingPermissionsKo.length > 0 && (
                          <>
                            <br />
                            누락 권한: {missingPermissionsKo.join(", ")}
                          </>
                        )}
                        <br />
                        Threads 계정 관리를 위해 재연동이 필요합니다. "재연동" 버튼을 클릭하여 권한을 다시 승인해주세요.
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  renderNotConnected() {
    return (
      <div className="instagram_account_page">
        <div className="container">
          <h1 className="page-title">계정 관리</h1>
          <p className="page-subtitle">인스타그램과 Threads 계정을 연결하고 관리합니다</p>
          <div className="section">
            <div className="section-header">
              <h2 className="section-title">인스타그램 계정</h2>
              <button className="btn btn-add" onClick={this.handleConnect}><span>+</span> 인스타그램 계정 추가</button>
            </div>
            <div className="empty-card">
              <div className="empty-icon"><i className="fa fa-brands fa-instagram"></i></div>
              <div className="empty-title">연결된 인스타그램 계정이 없습니다</div>
              <div className="empty-text">{this.state.instagramDirectLoginEnabled
                ? "Instagram 비즈니스 또는 크리에이터 계정을 직접 연결해 피드를 관리하세요"
                : <>페이스북을 통해 인스타그램 비즈니스 계정을 연결하여<br />피드를 자동으로 관리하세요</>}</div>
              <button className="btn btn-add" onClick={this.handleConnect}><span>+</span> 인스타그램 계정 추가</button>
            </div>
          </div>

          {this.renderThreadsSection()}

          {/* API 연동 섹션 */}
          {
            sessionStorage.getItem("roleType") != "2221" && (
              <div className="section">
                <h2 className="section-title solo">API 연동</h2>
                <div className="api-grid">
                  <div className="api-card">
                    {
                      this.state.rp_added_type != "Y" ? (
                        <div className="api-status status-inactive" />
                      ) :
                        this.state.rp_is_finish == 1
                          ? (<div className="api-status status-inactive" />)
                          : (<div className="api-status status-active" />)
                    }
                    <div className="api-icon-wrapper">
                      <div className="api-icon">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_2434_305)">
                          <path d="M9.79828 2.34113H4.21878C3.64599 2.34113 3.18164 2.81822 3.18164 3.40674V7.99969C3.18164 8.58821 3.64599 9.0653 4.21878 9.0653H9.79828C10.3711 9.0653 10.8354 8.58821 10.8354 7.99969V3.40674C10.8354 2.81822 10.3711 2.34113 9.79828 2.34113Z" fill=""/>
                          <path d="M9.79826 2.96796C10.0312 2.96796 10.2253 3.1674 10.2253 3.40674V7.99969C10.2253 8.23903 10.0312 8.43847 9.79826 8.43847H4.21876C3.98582 8.43847 3.7917 8.23903 3.7917 7.99969V3.40674C3.7917 3.1674 3.98582 2.96796 4.21876 2.96796H9.79826ZM9.79826 1.71429H4.21876C3.30918 1.71429 2.57153 2.47219 2.57153 3.40674V7.99969C2.57153 8.93424 3.30918 9.69213 4.21876 9.69213H9.79826C10.7078 9.69213 11.4455 8.93424 11.4455 7.99969V3.40674C11.4455 2.47219 10.7078 1.71429 9.79826 1.71429Z" fill="#1D1D1B"/>
                          <path d="M10.8409 11.4587H3.17607C2.8433 11.4587 2.57153 11.1795 2.57153 10.8318C2.57153 10.4842 2.8433 10.205 3.17607 10.205H10.8465C11.1793 10.205 11.451 10.4842 11.451 10.8318C11.451 11.1795 11.1793 11.4587 10.8465 11.4587H10.8409Z" fill="#1D1D1B"/>
                          <path d="M19.7814 2.34113H14.2019C13.6291 2.34113 13.1648 2.81822 13.1648 3.40674V7.99969C13.1648 8.58821 13.6291 9.0653 14.2019 9.0653H19.7814C20.3542 9.0653 20.8186 8.58821 20.8186 7.99969V3.40674C20.8186 2.81822 20.3542 2.34113 19.7814 2.34113Z" fill=""/>
                          <path d="M19.7814 2.96796C20.0144 2.96796 20.2085 3.1674 20.2085 3.40674V7.99969C20.2085 8.23903 20.0144 8.43847 19.7814 8.43847H14.2019C13.969 8.43847 13.7749 8.23903 13.7749 7.99969V3.40674C13.7749 3.1674 13.969 2.96796 14.2019 2.96796H19.7814ZM19.7814 1.71429H14.2019C13.2923 1.71429 12.5547 2.47219 12.5547 3.40674V7.99969C12.5547 8.93424 13.2923 9.69213 14.2019 9.69213H19.7814C20.691 9.69213 21.4286 8.93424 21.4286 7.99969V3.40674C21.4286 2.47219 20.691 1.71429 19.7814 1.71429Z" fill="#1D1D1B"/>
                          <path d="M20.824 11.4587H13.1536C12.8208 11.4587 12.5491 11.1795 12.5491 10.8318C12.5491 10.4842 12.8208 10.205 13.1536 10.205H20.824C21.1568 10.205 21.4286 10.4842 21.4286 10.8318C21.4286 11.1795 21.1568 11.4587 20.824 11.4587Z" fill="#1D1D1B"/>
                          <path d="M9.79828 13.1682H4.21878C3.64599 13.1682 3.18164 13.6453 3.18164 14.2338V18.8268C3.18164 19.4153 3.64599 19.8924 4.21878 19.8924H9.79828C10.3711 19.8924 10.8354 19.4153 10.8354 18.8268V14.2338C10.8354 13.6453 10.3711 13.1682 9.79828 13.1682Z" fill=""/>
                          <path d="M9.79826 13.795C10.0312 13.795 10.2253 13.9945 10.2253 14.2338V18.8268C10.2253 19.0661 10.0312 19.2656 9.79826 19.2656H4.21876C3.98582 19.2656 3.7917 19.0661 3.7917 18.8268V14.2338C3.7917 13.9945 3.98582 13.795 4.21876 13.795H9.79826ZM9.79826 12.5414H4.21876C3.30918 12.5414 2.57153 13.2993 2.57153 14.2338V18.8268C2.57153 19.7613 3.30918 20.5192 4.21876 20.5192H9.79826C10.7078 20.5192 11.4455 19.7613 11.4455 18.8268V14.2338C11.4455 13.2993 10.7078 12.5414 9.79826 12.5414Z" fill="#1D1D1B"/>
                          <path d="M10.8409 22.2858H3.17607C2.8433 22.2858 2.57153 22.0065 2.57153 21.6589C2.57153 21.3113 2.8433 21.0321 3.17607 21.0321H10.8465C11.1793 21.0321 11.451 21.3113 11.451 21.6589C11.451 22.0065 11.1793 22.2858 10.8465 22.2858H10.8409Z" fill="#1D1D1B"/>
                          <path d="M19.7814 13.1682H14.2019C13.6291 13.1682 13.1648 13.6453 13.1648 14.2338V18.8268C13.1648 19.4153 13.6291 19.8924 14.2019 19.8924H19.7814C20.3542 19.8924 20.8186 19.4153 20.8186 18.8268V14.2338C20.8186 13.6453 20.3542 13.1682 19.7814 13.1682Z" fill=""/>
                          <path d="M19.7814 13.795C20.0144 13.795 20.2085 13.9945 20.2085 14.2338V18.8268C20.2085 19.0661 20.0144 19.2656 19.7814 19.2656H14.2019C13.969 19.2656 13.7749 19.0661 13.7749 18.8268V14.2338C13.7749 13.9945 13.969 13.795 14.2019 13.795H19.7814ZM19.7814 12.5414H14.2019C13.2923 12.5414 12.5547 13.2993 12.5547 14.2338V18.8268C12.5547 19.7613 13.2923 20.5192 14.2019 20.5192H19.7814C20.691 20.5192 21.4286 19.7613 21.4286 18.8268V14.2338C21.4286 13.2993 20.691 12.5414 19.7814 12.5414Z" fill="#1D1D1B"/>
                          <path d="M20.824 22.2858H13.1536C12.8208 22.2858 12.5491 22.0065 12.5491 21.6589C12.5491 21.3113 12.8208 21.0321 13.1536 21.0321H20.824C21.1568 21.0321 21.4286 21.3113 21.4286 21.6589C21.4286 22.0065 21.1568 22.2858 20.824 22.2858Z" fill="#1D1D1B"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_2434_305">
                          <rect width="18.8571" height="20.5714" fill="white" transform="translate(2.57153 1.71429)"/>
                          </clipPath>
                          </defs>
                        </svg>
                      </div>
                    </div>
                    <div className="api-title">로보MD 진열</div>
                    <div className="api-description">AI 기반 상품 추천 및 자동 피드 생성</div>
                    <div className="api-info">
                      <div className="info-item">
                        <div className="info-label">상태</div>
                      </div>
                      <div className="info-item right">
                        <div className="info-value">
                          {
                            this.state.rp_added_type != "Y" ? (
                              <div className="info-value inactive">미연동</div>
                            ) :
                              this.state.rp_is_finish == 1
                                ? (<div className="info-value inactive">기간 만료</div>)
                                : (<div className="info-value">연결됨</div>)
                          }
                        </div>
                      </div>
                    </div>
                    {
                      this.state.rp_added_type != "Y" ? (
                        <button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>
                      ) :
                        this.state.rp_is_finish == 1
                          ? (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>)
                          : (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>진열 바로가기</button>)
                    }
                  </div>
                </div>
              </div>
            )
          }

          {/* 가이드 */}
          <div className="guide-box">
            <div className="guide-title">
              <span className="guide-icon">
                {/* 💡 */}
                <i className="fa fa-lightbulb-o"></i>
              </span>
              < span>시작하기 가이드</span>
            </div>
            <ul className="guide-list">
              <li>페이스북을 통해 인스타그램 비즈니스 계정을 먼저 연결해주세요.
                <span className="hover-underline" style={{ marginLeft: 5, cursor: "pointer", fontWeight: 600, color: "#05dbe2" }}
                title="새창으로 열기"
                onClick={() => {
                  window.open(
                    "https://robomdguide.notion.site/instagram-account",
                    "_blank"
                  );
                }}>{"[계정 연결 전 준비사항 보기]"}</span>
              </li>
              { sessionStorage.getItem("roleType") != "2221" && (
                <>
                  <li>카페24를 연결하면, 상품 정보가 자동으로 동기화됩니다.</li>
                  <li>로보MD 진열을 연결하면, 진열에 등록한 알고리즘이 자동으로 동기화됩니다.</li>
                </>
              )}
              <li>로보MD AI가 최적의 피드를 자동으로 생성해드립니다.</li>
              <li>여러 페이스북 계정을 연결하여 다수의 인스타그램 계정을 관리할 수 있습니다.</li>
            </ul>
          </div>
        </div>
      </div>
    );
  }

  // Instagram Login 계정은 Threads처럼 계정 카드를 바로 표시한다.
  // Facebook 로그인 그룹 및 기존 권한 검사 UI는 변경하지 않는다.
  renderDirectInstagramAccountCards = (account, { isLimitedPermission, isServiceUnavailable, showReconnectButton, health_message, missingPermissionsKo }) => (
    <div className="instagram-accounts" key={account.token_id} style={{ marginBottom: "16px" }}>
      {(account.instagram_account_list || []).map((instagram) => (
        <div
          className="account-card"
          key={instagram.instagram_access_token_seq}
          style={{ opacity: (isServiceUnavailable ? 0.5 : 1) }}
        >
          <div className="account-wrapper">
            <div className="account-left">
              <div className="account-avatar">
                {instagram.profile_picture_url ? (
                  <img src={instagram.profile_picture_url} alt="" />
                ) : (
                  <span>IG</span>
                )}
              </div>
              <div className="account-info">
                <div className="account-username">
                  {instagram.username}
                  {instagram.default_yn === "Y" && <span className="default-badge">기본</span>}
                </div>
                <div className="account-stats">
                  <span className="stat-item">팔로워
                    <span className="stat-value">
                      {instagram.total_follows_value != null
                        ? instagram.total_follows_value < 1000
                          ? instagram.total_follows_value
                          : (instagram.total_follows_value / 1000).toFixed(1) + 'K'
                        : '-'}
                    </span>
                  </span>
                  <span className="stat-item">게시물 <span className="stat-value">{instagram.media_count}</span></span>
                  <span className="stat-item">참여율
                    <span className="stat-value">
                      {instagram.engagement_rate != null ? instagram.engagement_rate.toFixed(1) + '%' : '-'}
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <div className="account-right">
              {showReconnectButton && (
                <button className="btn-outline" onClick={this.handleConnectAccount}>재연동</button>
              )}
              {!isServiceUnavailable && instagram.default_yn !== "Y" && (
                <button className="btn-outline" onClick={() => this.setDefaultInstagram(instagram.instagram_access_token_seq)}>
                  기본으로 설정
                </button>
              )}
              <button className="btn-outline" onClick={async () => {
                const confirmed = await this.openConfirmDialog({
                  title: "Instagram 직접 연결을 해제하시겠습니까?",
                  content: "기존 발행 이력은 유지됩니다."
                });
                if (!confirmed) return;
                try {
                  await http.post("/rest/shop/instagram/direct/disconnect", {
                    instagram_access_token_seq: instagram.instagram_access_token_seq
                  });
                  this.loadInstagramAccountList();
                } catch (e) {
                  this.setState({
                    warning_dialog_show_state: true,
                    warning_dialog_content: "Instagram 직접 연결 해제에 실패했습니다."
                  });
                }
              }}>연결 해제</button>
            </div>
          </div>

          {isLimitedPermission && (
            <div className="permission-alert permission-alert-limited" style={{ marginTop: "12px" }}>
              <span className="permission-alert-icon permission-alert-info-icon">i</span>
              <div className="permission-alert-text">
                최근 인사이트 API 접근 검사에서 거부 응답이 확인됐습니다. 인사이트 사용을 위해 재연동을 확인해 주세요. 기본 게시 기능까지 차단된 것은 아닙니다.
              </div>
            </div>
          )}
          {isServiceUnavailable && (
            <div className="permission-alert" style={{ marginTop: "12px" }}>
              <span className="permission-alert-icon">⚠️</span>
              <div className="permission-alert-text">
                <strong>{health_message || (missingPermissionsKo.length > 0 ? "필수 권한이 누락되었습니다." : "재연동 필요")}</strong>
                <br />
                인스타그램 계정 관리를 위해 재연동이 필요합니다. "재연동" 버튼을 클릭하여 권한을 다시 승인해주세요.
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );

  renderConnected() {
    return (
      <div className="container">
        <h1 className="page-title">계정 관리</h1>
        <p className="page-subtitle">인스타그램과 Threads 계정을 연결하고 관리합니다</p>

        {/* Facebook 그룹 */}
        <div className="section">
          <div className="section-header">
            <h2 className="section-title">인스타그램 계정</h2>
            <button className="btn btn-add" onClick={this.handleConnectAccount}>+ 인스타그램 계정 추가</button>
          </div>

          {
            this.state.account_list.map((account) => {
              // 헬스 결과
              const isInstagramDirectAccount = account.auth_provider === "INSTAGRAM";
              const health = this.state.healthByTokenId[account.token_id];
              const status = health?.status || (isInstagramDirectAccount ? "CHECKING" : undefined);
              const isDirectChecking = isInstagramDirectAccount && status === "CHECKING";
              const isDirectCheckFailed = isInstagramDirectAccount && status === "CHECK_FAILED";
              const health_message = health?.message;
              const missingPermissionsEn = health?.missing_permissions_en || [];
              const missingPermissionsKo = health?.missing_permissions_ko || [];

              // 삭제 전용 권한만 누락된 경우 서비스 자체는 정상 이용 가능하다.
              // 백엔드/프론트 배포 시점이 어긋나도 기존 MISSING_PERMISSIONS 응답을 안전하게 처리한다.
              const isLegacyDeleteOnlyMissing =
                status === "MISSING_PERMISSIONS" &&
                missingPermissionsEn.length > 0 &&
                missingPermissionsEn.every(permission => permission === "instagram_manage_contents");

              const isLimitedPermission = isInstagramDirectAccount
                ? status === "LIMITED_PERMISSIONS"
                : status === "LIMITED_PERMISSIONS" || isLegacyDeleteOnlyMissing;

              const isServiceUnavailable = isInstagramDirectAccount
                ? status === "MISSING_PERMISSIONS" || status === "TOKEN_INVALID"
                : ((!isLimitedPermission && status === "MISSING_PERMISSIONS") ||
                   status === "DATA_ACCESS_EXPIRED" ||
                   (status && status.startsWith("TOKEN_INVALID")));

              const showReconnectButton = isLimitedPermission || isServiceUnavailable;

              if (isInstagramDirectAccount) {
                return this.renderDirectInstagramAccountCards(account, {
                  isLimitedPermission,
                  isServiceUnavailable,
                  showReconnectButton,
                  health_message,
                  missingPermissionsKo
                });
              }

              return (
                <div className="facebook-group" key={account.token_id}>
                  <div className="facebook-header">
                    <div className="facebook-info">
                      <div className="facebook-icon">{isInstagramDirectAccount ? "IG" : "f"}</div>
                      <div className="facebook-details">
                        <div className="facebook-name">
                          {isInstagramDirectAccount ? "Instagram 직접 연결" : account.facebook_username}
                        </div>
                        <div className="facebook-status">
                          {!isServiceUnavailable ? (
                            <>
                              <div className={`status-indicator ${(isInstagramDirectAccount && (isDirectChecking || isDirectCheckFailed || isLimitedPermission)) ? "status-warning" : "status-connected"}`}></div>
                              <span className={`status-text ${(isInstagramDirectAccount && (isDirectChecking || isDirectCheckFailed || isLimitedPermission)) ? "status-warning-text" : "status-connected-text"}`}>
                                {isDirectChecking ? "연결 상태 확인 중" : isDirectCheckFailed ? "연결 상태 확인 실패" : "정상 연결"}
                              </span>
                              {isLimitedPermission && (
                                <span className="permission-limited-badge">
                                  {isInstagramDirectAccount ? "인사이트 접근 확인 필요" : "삭제 권한 추가 필요"}
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              <div className="status-indicator status-warning"></div>
                              <span className="status-text status-warning-text">
                                {status === "DATA_ACCESS_EXPIRED" 
                                  ? "데이터 접근 만료" 
                                  : (
                                      ( missingPermissionsKo.length > 0 ? "권한 부족 / " : "" )
                                      // + (health_message &&
                                      //     (health_message + " / " )
                                      //  )
                                      + "재연동 필요" 
                                    )
                                }
                              </span>
                              {missingPermissionsKo.length > 0 && (
                                <div className="permission-list">
                                  {missingPermissionsKo.map((label, idx) => (
                                    <span key={idx} className="permission-badge">{label} 누락</span>
                                  ))}
                                </div>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="facebook-actions">
                      {showReconnectButton ? (
                        <button
                          className="btn btn-small btn-reconnect"
                          onClick={() => {
                            // 서버 reauthorize_url은 환경별 redirect_uri가 맞지 않을 수 있으므로
                            // 현재 도메인 기준으로 만든 프론트 OAuth URL을 사용한다.
                            this.handleConnectAccount();
                          }}
                        >
                          재연동
                        </button>
                      ) : null}
                      {isInstagramDirectAccount ? (
                        <button className="btn btn-small btn-disconnect" onClick={async () => {
                          const confirmed = await this.openConfirmDialog({
                            title: "Instagram 직접 연결을 해제하시겠습니까?",
                            content: "기존 발행 이력은 유지됩니다."
                          });
                          if (!confirmed) return;
                          try {
                            await http.post("/rest/shop/instagram/direct/disconnect", {
                              instagram_access_token_seq: account.instagram_account_list?.[0]?.instagram_access_token_seq
                            });
                            this.loadInstagramAccountList();
                          } catch (e) {
                            this.setState({warning_dialog_show_state:true,
                              warning_dialog_content:"Instagram 직접 연결 해제에 실패했습니다."});
                          }
                        }}>연결 해제</button>
                      ) : (
                        <button className="btn btn-small btn-disconnect"
                          onClick={() => this.openFacebookModal(account.token_id, account.facebook_username)}
                        >연결 해제</button>
                      )}
                    </div>
                  </div>

                  {/* 일부 기능 권한 안내 */}
                  {isLimitedPermission && (
                    <div className="permission-alert permission-alert-limited">
                      <span className="permission-alert-icon permission-alert-info-icon">i</span>
                      <div className="permission-alert-text">
                        {isInstagramDirectAccount
                          ? "최근 인사이트 API 접근 검사에서 거부 응답이 확인됐습니다. 인사이트 사용을 위해 재연동을 확인해 주세요. 기본 게시 기능까지 차단된 것은 아닙니다."
                          : "인스타그램에 발행된 콘텐츠를 삭제하려면 \"재연동\"을 통해 삭제 권한을 승인해주세요."}
                      </div>
                    </div>
                  )}

                  {/* 서비스 이용에 영향을 주는 권한/만료 경고 */}
                  {isServiceUnavailable && (
                    <div className="permission-alert">
                      <span className="permission-alert-icon">⚠️</span>
                      <div className="permission-alert-text">
                        <strong>
                          {status === "DATA_ACCESS_EXPIRED"
                            ? "데이터 접근 권한이 만료되었습니다."
                            : health_message ? health_message
                              : missingPermissionsKo.length > 0 ? "필수 권한이 누락되었습니다." : "재연동 필요"}
                        </strong>
                        <br />
                        인스타그램 계정 관리를 위해 재연동이 필요합니다.
                        "재연동" 버튼을 클릭하여 권한을 다시 승인해주세요.
                      </div>
                    </div>
                  )}

                  <div className="instagram-section-header">
                    <div className="instagram-icon">
                      <img src="https://s3.ap-northeast-2.amazonaws.com/otdeal.file/instagram_logo.png" alt="instagram" />
                    </div>
                    <div className="instagram-name">연결된 인스타그램 계정</div>
                    <div className="instagram-count">{account.instagram_account_list.length}개</div>
                  </div>

                  <div className="instagram-accounts">
                    {
                      account.instagram_account_list.map((instagram) => {
                        return (
                          <div
                            className="account-card"
                            key={instagram.instagram_access_token_seq}
                            style={{ opacity: (isServiceUnavailable ? 0.5 : 1) }}
                          >
                            <div className="account-wrapper">
                              <div className="account-left">
                                <div className="account-avatar">
                                  <img src={instagram.profile_picture_url} alt="" />
                                </div>
                                <div className="account-info">
                                  <div className="account-username">
                                    {instagram.username}
                                    {instagram.default_yn === "Y" && <span className="default-badge">기본</span>}
                                  </div>
                                  <div className="account-stats">
                                    <span className="stat-item">팔로워
                                      <span className="stat-value">
                                        {
                                          instagram.total_follows_value != null
                                            ? instagram.total_follows_value < 1000
                                              ? instagram.total_follows_value
                                              : (instagram.total_follows_value / 1000).toFixed(1) + 'K'
                                            : '-'
                                        }
                                      </span>
                                    </span>
                                    <span className="stat-item">게시물 <span className="stat-value">{instagram.media_count}</span></span>
                                    <span className="stat-item">참여율
                                      <span className="stat-value">
                                        {instagram.engagement_rate != null ? instagram.engagement_rate.toFixed(1) + '%' : '-'}
                                      </span>
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div className="account-right">
                                {!isServiceUnavailable && instagram.default_yn !== "Y" ? (
                                  <button
                                    className="btn-outline"
                                    onClick={() => this.setDefaultInstagram(instagram.instagram_access_token_seq)}
                                  >
                                    기본으로 설정
                                  </button>
                                ) : (
                                  null
                                )}
                              </div>
                            </div>
                          </div>
                        )
                      })
                    }
                  </div>
                </div>
              )
            })
          }

        </div>

        {this.renderThreadsSection()}

        {/* 타 서비스 연동 섹션 */}
        {
          sessionStorage.getItem("roleType") != "2221" && (
            <div className="section">
              <h2 className="section-title solo">서비스 연동</h2>
              <div className="api-grid">
                <div className="api-card">
                  {
                    this.state.rp_added_type != "Y" ? (
                      <div className="api-status status-inactive" />
                    ) :
                      this.state.rp_is_finish == 1
                        ? (<div className="api-status status-inactive" />)
                        : (<div className="api-status status-active" />)
                  }
                  <div className="api-icon-wrapper">
                    <div className="api-icon">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_2434_305)">
                        <path d="M9.79828 2.34113H4.21878C3.64599 2.34113 3.18164 2.81822 3.18164 3.40674V7.99969C3.18164 8.58821 3.64599 9.0653 4.21878 9.0653H9.79828C10.3711 9.0653 10.8354 8.58821 10.8354 7.99969V3.40674C10.8354 2.81822 10.3711 2.34113 9.79828 2.34113Z" fill=""/>
                        <path d="M9.79826 2.96796C10.0312 2.96796 10.2253 3.1674 10.2253 3.40674V7.99969C10.2253 8.23903 10.0312 8.43847 9.79826 8.43847H4.21876C3.98582 8.43847 3.7917 8.23903 3.7917 7.99969V3.40674C3.7917 3.1674 3.98582 2.96796 4.21876 2.96796H9.79826ZM9.79826 1.71429H4.21876C3.30918 1.71429 2.57153 2.47219 2.57153 3.40674V7.99969C2.57153 8.93424 3.30918 9.69213 4.21876 9.69213H9.79826C10.7078 9.69213 11.4455 8.93424 11.4455 7.99969V3.40674C11.4455 2.47219 10.7078 1.71429 9.79826 1.71429Z" fill="#1D1D1B"/>
                        <path d="M10.8409 11.4587H3.17607C2.8433 11.4587 2.57153 11.1795 2.57153 10.8318C2.57153 10.4842 2.8433 10.205 3.17607 10.205H10.8465C11.1793 10.205 11.451 10.4842 11.451 10.8318C11.451 11.1795 11.1793 11.4587 10.8465 11.4587H10.8409Z" fill="#1D1D1B"/>
                        <path d="M19.7814 2.34113H14.2019C13.6291 2.34113 13.1648 2.81822 13.1648 3.40674V7.99969C13.1648 8.58821 13.6291 9.0653 14.2019 9.0653H19.7814C20.3542 9.0653 20.8186 8.58821 20.8186 7.99969V3.40674C20.8186 2.81822 20.3542 2.34113 19.7814 2.34113Z" fill=""/>
                        <path d="M19.7814 2.96796C20.0144 2.96796 20.2085 3.1674 20.2085 3.40674V7.99969C20.2085 8.23903 20.0144 8.43847 19.7814 8.43847H14.2019C13.969 8.43847 13.7749 8.23903 13.7749 7.99969V3.40674C13.7749 3.1674 13.969 2.96796 14.2019 2.96796H19.7814ZM19.7814 1.71429H14.2019C13.2923 1.71429 12.5547 2.47219 12.5547 3.40674V7.99969C12.5547 8.93424 13.2923 9.69213 14.2019 9.69213H19.7814C20.691 9.69213 21.4286 8.93424 21.4286 7.99969V3.40674C21.4286 2.47219 20.691 1.71429 19.7814 1.71429Z" fill="#1D1D1B"/>
                        <path d="M20.824 11.4587H13.1536C12.8208 11.4587 12.5491 11.1795 12.5491 10.8318C12.5491 10.4842 12.8208 10.205 13.1536 10.205H20.824C21.1568 10.205 21.4286 10.4842 21.4286 10.8318C21.4286 11.1795 21.1568 11.4587 20.824 11.4587Z" fill="#1D1D1B"/>
                        <path d="M9.79828 13.1682H4.21878C3.64599 13.1682 3.18164 13.6453 3.18164 14.2338V18.8268C3.18164 19.4153 3.64599 19.8924 4.21878 19.8924H9.79828C10.3711 19.8924 10.8354 19.4153 10.8354 18.8268V14.2338C10.8354 13.6453 10.3711 13.1682 9.79828 13.1682Z" fill=""/>
                        <path d="M9.79826 13.795C10.0312 13.795 10.2253 13.9945 10.2253 14.2338V18.8268C10.2253 19.0661 10.0312 19.2656 9.79826 19.2656H4.21876C3.98582 19.2656 3.7917 19.0661 3.7917 18.8268V14.2338C3.7917 13.9945 3.98582 13.795 4.21876 13.795H9.79826ZM9.79826 12.5414H4.21876C3.30918 12.5414 2.57153 13.2993 2.57153 14.2338V18.8268C2.57153 19.7613 3.30918 20.5192 4.21876 20.5192H9.79826C10.7078 20.5192 11.4455 19.7613 11.4455 18.8268V14.2338C11.4455 13.2993 10.7078 12.5414 9.79826 12.5414Z" fill="#1D1D1B"/>
                        <path d="M10.8409 22.2858H3.17607C2.8433 22.2858 2.57153 22.0065 2.57153 21.6589C2.57153 21.3113 2.8433 21.0321 3.17607 21.0321H10.8465C11.1793 21.0321 11.451 21.3113 11.451 21.6589C11.451 22.0065 11.1793 22.2858 10.8465 22.2858H10.8409Z" fill="#1D1D1B"/>
                        <path d="M19.7814 13.1682H14.2019C13.6291 13.1682 13.1648 13.6453 13.1648 14.2338V18.8268C13.1648 19.4153 13.6291 19.8924 14.2019 19.8924H19.7814C20.3542 19.8924 20.8186 19.4153 20.8186 18.8268V14.2338C20.8186 13.6453 20.3542 13.1682 19.7814 13.1682Z" fill=""/>
                        <path d="M19.7814 13.795C20.0144 13.795 20.2085 13.9945 20.2085 14.2338V18.8268C20.2085 19.0661 20.0144 19.2656 19.7814 19.2656H14.2019C13.969 19.2656 13.7749 19.0661 13.7749 18.8268V14.2338C13.7749 13.9945 13.969 13.795 14.2019 13.795H19.7814ZM19.7814 12.5414H14.2019C13.2923 12.5414 12.5547 13.2993 12.5547 14.2338V18.8268C12.5547 19.7613 13.2923 20.5192 14.2019 20.5192H19.7814C20.691 20.5192 21.4286 19.7613 21.4286 18.8268V14.2338C21.4286 13.2993 20.691 12.5414 19.7814 12.5414Z" fill="#1D1D1B"/>
                        <path d="M20.824 22.2858H13.1536C12.8208 22.2858 12.5491 22.0065 12.5491 21.6589C12.5491 21.3113 12.8208 21.0321 13.1536 21.0321H20.824C21.1568 21.0321 21.4286 21.3113 21.4286 21.6589C21.4286 22.0065 21.1568 22.2858 20.824 22.2858Z" fill="#1D1D1B"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_2434_305">
                        <rect width="18.8571" height="20.5714" fill="white" transform="translate(2.57153 1.71429)"/>
                        </clipPath>
                        </defs>
                      </svg>
                    </div>
                  </div>
                  <div className="api-title">로보MD 진열</div>
                  <div className="api-description">AI 기반 상품 추천 및 자동 피드 생성</div>
                  <div className="api-info">
                    <div className="info-item">
                      <div className="info-label">상태</div>
                    </div>
                    <div className="info-item right">
                      <div className="info-value">
                        {
                          this.state.rp_added_type != "Y" ? (
                            <div className="info-value inactive">미연동</div>
                          ) :
                            this.state.rp_is_finish == 1
                              ? (<div className="info-value inactive">기간 만료</div>)
                              : (<div className="info-value">연결됨</div>)
                        }
                      </div>
                    </div>
                  </div>
                  {
                    this.state.rp_added_type != "Y" ? (
                      <button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>
                    ) :
                      this.state.rp_is_finish == 1
                        ? (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>연결하기</button>)
                        : (<button className="btn-api btn-connect" onClick={() => this.goRpService()}>진열 바로가기</button>)
                  }
                </div>
              </div>
            </div>
          )
      }
      </div>
    );
  }

  openConfirmDialog(props) {
    console.log("[openConfirmDialog] props:", props);
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }

  render() {
    return (
      <>
        <style>
          {
            `
              .common_popup_frame_v2_content:has(.instagram-no-accounts) {
                max-width: 720px !important;
                width: min(720px, calc(100vw - 32px)) !important;
                word-break: keep-all;
              }
              .hover-underline:hover {
                text-decoration: underline;
                text-decoration-thickness: 1.5px !important;
                text-underline-offset: 3px;
                font-weight: 700;
              }

              .instagram_account_page .btn-add:active {
                  transform: scale(1) !important;
              }

              .instagram_account_page .api-icon {
                font-size: 0 !important;
              }


              .instagram_account_page .permission-limited-badge {
                display: inline-flex;
                align-items: center;
                margin-left: 8px;
                padding: 3px 8px;
                border: 1px solid #9ee7f0;
                border-radius: 999px;
                background: #f0fdff;
                color: #16869a;
                font-size: 12px;
                font-weight: 700;
                line-height: 1.4;
              }

              .instagram_account_page .permission-alert.permission-alert-limited {
                border-color: #b7e8ed !important;
                background: #f3fcfd !important;
              }

              .instagram_account_page .permission-alert.permission-alert-limited .permission-alert-text,
              .instagram_account_page .permission-alert.permission-alert-limited .permission-alert-text strong {
                color: #0A1A2F !important;
              }

              .instagram_account_page .permission-alert-info-icon {
                display: inline-flex;
                align-items: center;
                justify-content: center;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #35a9c9;
                color: #fff;
                font-size: 13px;
                font-weight: 800;
                font-style: normal;
                flex-shrink: 0;
              }
            `
          }
        </style>
        <div id='page-wrapper' className="container eventFormPromotion" style={{ backgroundColor: '#fafaf' }}>
          <div className="instagram_account_page">
            {this.state.isConnected ? this.renderConnected() : this.renderNotConnected()}
            {
              this.state.showFacebookDisconnectModal && (
                <div className="modal active" id="facebookDisconnectModal">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h3 className="modal-title">페이스북 계정 연결을 해제하시겠습니까?</h3>
                      <p className="modal-subtitle" id="facebookModalDescription">
                        {this.state.currentfacebookAccountName} 계정의 연결을 해제합니다.
                      </p>
                    </div>

                    <div className="modal-warning">
                      <div className="warning-title">⚠️ 연결 해제 시 주의사항</div>
                      <ul className="warning-list">
                        <li>해당 페이스북 계정에 연결된 모든 인스타그램 계정이 함께 해제됩니다</li>
                        <li>자동 피드 생성 및 예약 게시물이 모두 중지됩니다</li>
                        <li>계정 통계 및 분석 데이터에 접근할 수 없습니다</li>
                        <li>다시 연결하려면 페이스북에서 재인증이 필요합니다</li>
                      </ul>
                    </div>

                    <div className="modal-footer">
                      <button className="btn btn-cancel" onClick={() => { this.closeFacebookModal() }}>취소</button>
                      <button className="btn btn-danger" onClick={() => { this.disconnectAllPermissions(this.state.currentFacebookTokenId) }}>연결 해제</button>
                    </div>
                  </div>
                </div>
              )
            }
            {
              this.state.showThreadsDisconnectModal && (
                <div className="modal active" id="threadsDisconnectModal">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h3 className="modal-title">Threads 계정 연결을 해제하시겠습니까?</h3>
                      <p className="modal-subtitle">
                        {this.state.currentThreadsAccountName} 계정의 연결을 해제합니다.
                      </p>
                    </div>

                    <div className="modal-warning">
                      <div className="warning-title">⚠️ 연결 해제 시 주의사항</div>
                      <ul className="warning-list">
                        <li>Threads 게시 및 자동화에서 해당 계정을 사용할 수 없습니다</li>
                        <li>Threads 토큰은 Instagram/Facebook 토큰과 별도로 관리됩니다</li>
                        <li>다시 연결하려면 Threads 인증이 필요합니다</li>
                      </ul>
                    </div>

                    <div className="modal-footer">
                      <button className="btn btn-cancel" onClick={() => { this.closeThreadsModal() }}>취소</button>
                      <button
                        className="btn btn-danger"
                        onClick={() => { this.disconnectThreadsAccount(this.state.currentThreadsAccessTokenSeq) }}
                      >
                        연결 해제
                      </button>
                    </div>
                  </div>
                </div>
              )
            }
          </div>
        </div>
        {/* 안내 문구 전달용 기본 다이얼로그 */
          (this.state.basic_dialog_show_state === true)
            ? <BasicDialogV2
              content={this.state.basic_dialog_content}
              content2={this.state.basic_dialog_content2}
              button_list={this.state.basic_dialog_button_list}
            />
            : ''
        }
        {
          /* 연결한 계정을 선택하는 팝업 */
          this.state.show_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({ show_account_connect_popup: false })}
            >
              <div className="instagram_account_page">
                {(this.state.add_account_list || []).length === 0 ? (
                  <>
                    <div
                      className="instagram-no-accounts instagram-connect-guide-modal"
                      style={{
                        padding: "28px 36px 32px",
                        textAlign: "center",
                        color: "var(--deep-navy, #0A1A2F)",
                        lineHeight: "1.6",
                        wordBreak: "keep-all",
                      }}
                    >
                      <div
                        style={{
                          width: "70px",
                          height: "70px",
                          margin: "0 auto 18px",
                          borderRadius: "50%",
                          background: "rgba(0, 226, 230, 0.18)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <div
                          style={{
                            width: "52px",
                            height: "52px",
                            borderRadius: "50%",
                            background: "var(--primary-mint, #00e2e6)",
                            color: "#fff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "32px",
                            fontWeight: 900,
                            boxShadow: "0 8px 18px rgba(0, 226, 230, 0.35)",
                          }}
                        >
                          !
                        </div>
                      </div>

                      <div
                        style={{
                          color: "var(--primary-mint-hover, #00bfc2)",
                          fontSize: "17px",
                          fontWeight: 900,
                          marginBottom: "12px",
                        }}
                      >
                        인스타그램 필수가이드 확인
                      </div>

                      <div
                        style={{
                          color: "var(--deep-navy, #0A1A2F)",
                          fontSize: "26px",
                          fontWeight: 900,
                          lineHeight: "1.35",
                          letterSpacing: "-0.8px",
                        }}
                      >
                        인스타그램 규정상 <br/>
                        아래 필수 3가지 조건을 가이드를 따라 변경 후 <br/>
                        다시 계정 추가를 진행해주세요
                      </div>

                      <div
                        style={{
                          height: "1px",
                          background: "#d1d5db",
                          margin: "28px 0 22px",
                        }}
                      />

                      <div
                        style={{
                          textAlign: "left",
                          color: "var(--deep-navy, #0A1A2F)",
                          fontSize: "15px",
                          fontWeight: 700,
                          marginBottom: "16px",
                        }}
                      >
                        인스타그램 자동관리를 사용하려면 아래 3가지가 모두 필요합니다.
                      </div>

                      <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                        {[
                          "인스타그램 프로페셔널 계정 전환 (개인 계정 연동 불가)",
                          "페이스북 비즈니스 페이지 개설",
                          "인스타그램 계정과 페이스북 페이지 상호 연결",
                        ].map((item, index) => (
                          <div
                            key={item}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "14px",
                              minHeight: "54px",
                              padding: "0 16px",
                              border: "1px solid #dfe5ec",
                              borderRadius: "8px",
                              background: "#fff",
                              color: "var(--deep-navy, #0A1A2F)",
                              fontSize: "15px",
                              fontWeight: 700,
                            }}
                          >
                            <span
                              style={{
                                width: "22px",
                                height: "22px",
                                borderRadius: "50%",
                                border: "2px solid var(--primary-mint-hover, #00bfc2)",
                                color: "var(--primary-mint-hover, #00bfc2)",
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: "13px",
                                fontWeight: 900,
                                flexShrink: 0,
                              }}
                            >
                              ✓
                            </span>
                            <span>{index + 1}. {item}</span>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "flex-start",
                          marginTop: "22px",
                          padding: "16px 18px",
                          border: "1px solid #9ee7f0",
                          borderRadius: "8px",
                          background: "linear-gradient(180deg, #f0fdff 0%, #eafaff 100%)",
                          color: "var(--deep-navy, #0A1A2F)",
                          textAlign: "left",
                          fontSize: "14px",
                          fontWeight: 700,
                          lineHeight: "1.6",
                        }}
                      >
                        <span
                          style={{
                            width: "21px",
                            height: "21px",
                            borderRadius: "50%",
                            background: "#35a9c9",
                            color: "#fff",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            fontWeight: 900,
                            flexShrink: 0,
                            marginTop: "1px",
                          }}
                        >
                          i
                        </span>
                        <span>
                          위 3가지 중 하나라도 설정되지 않으면 계정 연동이 되지 않습니다.
                          <br />
                          설정 방법은 사용가이드에서 확인해주세요.
                        </span>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: "26px",
                          marginTop: "28px",
                        }}
                      >
                        <button
                          className="btn btn-primary"
                          style={{
                            height: "52px",
                            borderRadius: "10px",
                            fontSize: "15px",
                            fontWeight: 900,
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "6px",
                            border: "none",
                            background: "var(--primary-mint, #00e2e6)",
                            color: "var(--deep-navy, #0A1A2F)",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            window.open(
                              "https://iclave.notion.site/Instagram-Facebook-2d363ab4c3ce800b9d58c0d0aaa0d9ce?source=copy_link",
                              "_blank"
                            );
                          }}
                        >
                          <span style={{ fontSize: "18px", lineHeight: 1 }}>↗</span>
                          가이드 바로 보기
                        </button>

                        <button
                          className="btn"
                          style={{
                            height: "52px",
                            borderRadius: "10px",
                            background: "#f1f5f9",
                            color: "#111827",
                            fontSize: "15px",
                            fontWeight: 900,
                            boxShadow: "none",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            border: "none",
                            cursor: "pointer",
                          }}
                          onClick={() => this.setState({ show_account_connect_popup: false })}
                        >
                          닫기
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                  <h5 style={{ marginBottom: 20 }}>연결할 인스타그램 계정을 선택해주세요</h5>
                  {
                    (this.state.add_account_list || []).map((account) => (
                      <div className="instagram-accounts" key={account.token_id}>
                        {(Array.isArray(account.instagram_account_list)
                          ? account.instagram_account_list
                          : []
                        )
                          .filter((instagram) => instagram && instagram.instagram_access_token_seq)
                          .map((instagram) => (
                            <div
                              className="account-card"
                              key={instagram.instagram_access_token_seq}
                              onClick={(e) => {
                                if (e.target.closest('input[type="checkbox"], label')) return;

                                let selected_account_list = [...this.state.selected_account_list];
                                const v = String(instagram.instagram_access_token_seq);

                                if (selected_account_list.includes(v)) {
                                  selected_account_list = selected_account_list.filter(seq => seq !== v);
                                } else {
                                  selected_account_list.push(v);
                                }

                                this.setState({ selected_account_list });
                              }}
                              style={{
                                display: "flex",
                                gap: "18px",
                                cursor: "pointer",
                                userSelect: "none",
                                WebkitUserSelect: "none",
                                msUserSelect: "none",
                                WebkitUserDrag: "none",
                                WebkitTouchCallout: "none",
                              }}
                            >
                              <CheckBox
                                id={String(instagram.instagram_access_token_seq)}
                                value={String(instagram.instagram_access_token_seq)}
                                checked={this.state.selected_account_list.includes(
                                  String(instagram.instagram_access_token_seq)
                                )}
                                onChangeCheck={() => {
                                  let selected_account_list = [...this.state.selected_account_list];
                                  const v = String(instagram.instagram_access_token_seq);

                                  if (selected_account_list.includes(v)) {
                                    selected_account_list = selected_account_list.filter(seq => seq !== v);
                                  } else {
                                    selected_account_list.push(v);
                                  }

                                  this.setState({ selected_account_list });
                                }}
                              />

                              <div className="account-wrapper">
                                <div className="account-left">
                                  <div className="account-avatar">
                                    {!!instagram.profile_picture_url && (
                                      <img src={instagram.profile_picture_url} alt="" />
                                    )}
                                  </div>
                                  <div className="account-info">
                                    <div className="account-username">
                                      {instagram.username || "(username 없음)"}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          ))}
                      </div>
                    ))
                  }
                  <div
                    style={{
                      display: "flex",
                      width: "100%",
                      justifyContent: "flex-end",
                      marginTop: "20px",
                      padding: "0 0 max(12px, env(safe-area-inset-bottom))",
                    }}
                    onPointerDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                  >
                    <button
                      type="button"
                      className="btn btn-primary"
                      style={{ minHeight: "44px", touchAction: "manipulation", transform: "scale(1)" }}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.updateSelectedAccountsUseYn();
                      }}
                    >
                      연결하기
                    </button>
                  </div>
                  </>
                )}
              </div>
            </PopupFrameV2>
          )
        }
        {
          /* 연결한 Threads 계정을 선택하는 팝업 */
          this.state.show_threads_account_connect_popup && (
            <PopupFrameV2
              className={"account-connect-popup"}
              maxWidth={"950px"}
              onClose={() => this.setState({ show_threads_account_connect_popup: false })}
            >
              <div className="instagram_account_page">
                <h5 style={{ marginBottom: 20 }}>연결할 Threads 계정을 선택해주세요.</h5>
                <div className="instagram-accounts">
                  {(this.state.add_threads_account_list || []).map((threads) => {
                    const seq = String(threads.threads_access_token_seq || "");
                    const selected = (this.state.selected_threads_account_list || []).map(String).includes(seq);
                    return (
                      <div
                        className="account-card"
                        key={seq}
                        onClick={(e) => {
                          if (e.target.closest('input[type="checkbox"], label')) return;
                          this.toggleThreadsConnectSelection(seq);
                        }}
                        style={{
                          display: "flex",
                          gap: "18px",
                          cursor: "pointer",
                          userSelect: "none",
                          WebkitUserSelect: "none",
                          msUserSelect: "none",
                          WebkitUserDrag: "none",
                          WebkitTouchCallout: "none",
                        }}
                      >
                        <CheckBox
                          id={`threads-connect-${seq}`}
                          value={seq}
                          checked={selected}
                          onChangeCheck={() => this.toggleThreadsConnectSelection(seq)}
                        />

                        <div className="account-wrapper">
                          <div className="account-left">
                            <div className="account-avatar threads-avatar">
                              {threads.profile_picture_url ? (
                                <img src={threads.profile_picture_url} alt="" />
                              ) : (
                                <span>T</span>
                              )}
                            </div>
                            <div className="account-info">
                              <div className="account-username">
                                {threads.username || threads.threads_user_id || "Threads 계정"}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "flex-end",
                    marginTop: "20px",
                    padding: "0 0 max(12px, env(safe-area-inset-bottom))",
                  }}
                  onPointerDown={(e) => e.stopPropagation()}
                  onTouchStart={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ minHeight: "44px", touchAction: "manipulation", transform: "scale(1)" }}
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      this.updateSelectedThreadsAccountsUseYn();
                    }}
                  >
                    연결하기
                  </button>
                </div>
              </div>
            </PopupFrameV2>
          )
        }
        {this.renderThreadsMobileOAuthGuide()}
        {
          /* 인스타그램 계정 연결 전달용 기본 다이얼로그 */
          (this.state.warning_dialog_show_state === true)
            ? <WarningDialog
              content={this.state.warning_dialog_content}
                button_list={[{
                    title : "확인",
                    event_method : () => { this.setState({warning_dialog_show_state : false}) }
                }]}
                popup_close={() => {this.setState({warning_dialog_show_state : false})}}
            />
            : ''
        }
      </>
    )
  }
}